import { getOrgId } from '.';
import { AgentApiService } from '../services/general';

export type PresetType = { text: string; label: string };

export const getAgentName = async (
  agentId: string,
  organizationId?: string
): Promise<string> => {
  const agent = await AgentApiService.getAgentById(
    organizationId || getOrgId(),
    agentId
  );
  return agent?.agent_name || '';
};

export const getAgentPresets = async (
  agentId: string
): Promise<PresetType[]> => {
  const agent = await AgentApiService.getAgentById(getOrgId(), agentId);
  return agent?.pipeline_settings?.agent_preset_greetings || dummyPresets;
};

export const getShortAgents = async (
  organizationId?: string
): Promise<ShortAgentType[]> => {
  const tenantId = organizationId || getOrgId();
  const agents = await AgentApiService.getShortAgents(tenantId);

  return agents
    .map(
      (agent): ShortAgentType => ({
        tenantId,
        id: agent.id || '',
        name: agent.title || '',
      })
    )
    .filter(agent => agent.id);
};

const dummyPresets = [
  'Create a new HR report',
  'Schedule from interview',
  'Create a new HR report',
  'Find policy details',
  'Analyze payroll data',
  'Compose an announcement payroll data',
];
